export default function sortInPlaceByKey<T>(array: T[], key: (x: T) => any): T[] {
    return array.sort((a, b) => (key(a) < key(b) ? -1 : key(a) > key(b) ? 1 : 0))
}
